<template>
  <v-container fluid>
    <v-row dense>
      <v-col cols="12">
        <v-card class="rounded-lg">
          <v-card-title class="am-t2 bold">
            <v-row dense class="space-between align-center">
              <div>Utilisateurs rattachés</div>
            </v-row>
          </v-card-title>
          <v-data-table
            :headers="usagersHeaders"
            :items="usagersIdentifies"
            :items-per-page="usagersConfig.itemsPerPage"
            :sort-by="usagersConfig.sortBy"
            :sort-desc="usagersConfig.sortDesc"
            must-sort
            :footer-props="{
              'items-per-page-options': [-1, 10, 20, 50],
            }"
          >
            <template #item.gestion="{ item }">
              {{ item.gestion ? "Oui" : "Non" }}
            </template>
            <template #item.depot="{ item }">
              {{ item.depot ? "Oui" : "Non" }}
            </template>
            <template #item.actions="{ item }">
              <span class="d-flex justify-center align-center">
                <a-tooltip-icon-button
                  v-if="gestion"
                  icon="mdi-pen"
                  tooltip="Modifier les droits de l'utilisateur"
                  @click="modifie(item)"
                />

                <a-tooltip-icon-button
                  v-if="gestion || item.moi"
                  icon="mdi-delete"
                  tooltip="Supprimer le rattachement de l'utilisateur à l'association"
                  @click="supprime(item)"
                />
              </span>
            </template>
          </v-data-table>
        </v-card>
      </v-col>

      <v-col cols="12">
        <v-card class="rounded-lg">
          <v-card-title>
            <span class="am-t2 bold">Demandes de rattachement</span>
          </v-card-title>
          <v-data-table
            :headers="demandesConfig.headers"
            :items="rattachementsDemandes"
            :items-per-page="demandesConfig.itemsPerPage"
            :sort-by="demandesConfig.sortBy"
            :sort-desc="demandesConfig.sortDesc"
            must-sort
            :footer-props="{
              'items-per-page-options': [-1, 10, 20, 50],
            }"
          >
            <template #item.statut="{ item }">
              <v-chip :color="item.statutColor">{{ item.statut }}</v-chip>
            </template>
          </v-data-table>
        </v-card>
      </v-col>

      <v-col cols="12">
        <v-card class="rounded-lg">
          <v-card-title>
            <span class="am-t2 bold">Invitations</span>
          </v-card-title>
          <v-data-table
            :headers="invitationsHeaders"
            :items="invitations"
            :items-per-page="invitationsConfig.itemsPerPage"
            :sort-by="invitationsConfig.sortBy"
            :sort-desc="invitationsConfig.sortDesc"
            must-sort
            :footer-props="{
              'items-per-page-options': [-1, 10, 20, 50],
            }"
          >
            <template #item.statut="{ item }">
              <v-chip :color="item.statutColor">{{ item.statut }}</v-chip>
            </template>
            <template #item.gestion="{ item }">
              {{ item.gestion ? "Oui" : "Non" }}
            </template>
            <template #item.depot="{ item }">
              {{ item.depot ? "Oui" : "Non" }}
            </template>
            <template #item.actions="{ item }">
              <span class="d-flex justify-center align-center" v-if="item.reference">
                <a-tooltip-icon-button
                  icon="mdi-email"
                  tooltip="Renvoyer l'invitation"
                  @click="reenvoiInvitation(item)"
                />

                <a-tooltip-icon-button
                  icon="mdi-delete"
                  tooltip="Supprimer l'invitation"
                  @click="supprimeInvitation(item)"
                />
              </span>
            </template>
          </v-data-table>
          <template v-if="gestion">
            <v-card-actions class="justify-center">
              Vous souhaitez rattacher de nouveaux usagers à l'association, envoyez leur
              une invitation.
            </v-card-actions>
            <v-card-actions class="justify-center">
              <v-btn @click="invite" color="primary">Envoyer une invitation</v-btn>
            </v-card-actions>
          </template>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import copy from "@/services/copy";
import { mapGetters } from "vuex";

export default {
  props: {
    usagers: {
      type: Array,
      default: () => [],
    },
    gestion: {
      type: Boolean,
      default: false,
    },
    rattachementsDemandes: {
      type: Array,
      default: () => [],
    },
    invitations: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      usagersConfig: {
        itemsPerPage: 20,
        sortBy: "email",
        sortDesc: false,
      },
      invitationsConfig: {
        itemsPerPage: 20,
        sortBy: "email",
        sortDesc: false,
      },
      demandesConfig: {
        itemsPerPage: 20,
        sortBy: "email",
        sortDesc: false,
        headers: [
          {
            text: "Courriel",
            value: "email",
            cellClass: "email",
            sortable: true,
          },
          {
            text: "Nom",
            value: "nom",
            sortable: true,
          },
          {
            text: "Prénom",
            value: "prenom",
            sortable: true,
          },
          {
            text: "Fonction",
            value: "fonction",
            sortable: true,
          },
        ],
      },
    };
  },
  computed: {
    ...mapGetters({
      uuidUtilisateur: "utilisateur/uuid",
    }),
    usagersIdentifies() {
      return this.usagers.map(u => ({ ...u, moi: u.uuid === this.uuidUtilisateur }));
    },
    usagersHeaders() {
      const headers = [
        {
          text: "Courriel",
          value: "email",
          cellClass: "email",
          sortable: true,
        },
        {
          text: "Nom",
          value: "nom",
          sortable: true,
        },
        {
          text: "Prénom",
          value: "prenom",
          sortable: true,
        },
        {
          text: "Fonction",
          value: "fonction",
          sortable: true,
          width: "250px",
        },
        {
          text: "Droit de gestion",
          value: "gestion",
          sortable: true,
        },
        {
          text: "Droit de dépôt",
          value: "depot",
          sortable: true,
        },
      ];

      headers.push({
        text: "Actions",
        sortable: false,
        value: "actions",
        width: "100px",
        align: "center",
      });

      return headers;
    },
    invitationsHeaders() {
      const headers = [
        {
          text: "Courriel",
          value: "email",
          cellClass: "email",
          sortable: true,
        },
        {
          text: "Fonction",
          value: "fonction",
          sortable: true,
          width: "250px",
        },
        {
          text: "Droit de gestion",
          value: "gestion",
          sortable: true,
        },
        {
          text: "Droit de dépôt",
          value: "depot",
          sortable: true,
        },
      ];

      if (this.gestion) {
        headers.push({
          text: "Actions",
          sortable: false,
          value: "actions",
          width: "100px",
          align: "center",
        });
      }

      return headers;
    },
  },
  methods: {
    supprime(item) {
      this.$emit("supprime", copy(item));
    },
    supprimeInvitation(item) {
      this.$emit("supprimeInvitation", copy(item));
    },
    modifie(item) {
      this.$emit("modifie", copy(item));
    },
    invite() {
      this.$emit("invite");
    },
    reenvoiInvitation(item) {
      this.$emit("reenvoiInvitation", copy(item));
    },
  },
};
</script>
